import { Form, Tag, TreeSelect } from "antd";
import React, { useEffect, useState } from "react";
import type { TreeSelectProps } from "antd";
import { GetAntIcon } from "../utils/ant_icons";

interface TreeFormProps {
	label: string;
	required: boolean;
	tooltip?: string;
	name: string;
	selectAllLabel?: string;
	dataObject: any;
}

type TreeNode = {
	title: string;
	key: string;
	value: string;
	children?: TreeNode[];
};

function TreeForm({
	label,
	required,
	tooltip,
	name,
	selectAllLabel,
	dataObject,
}: TreeFormProps) {
	const [treeData, setTreeData] = useState<TreeNode[]>([]);
	const [value, setValue] = useState<string[]>([]);

	const convertTreeSelectData = (data: any): TreeNode[] => {
		console.log("debug data", data);
		if (!data || data.length === 0) {
			return [];
		}

		const selectAll: TreeNode = {
			title: selectAllLabel || "Select All",
			key: selectAllLabel || "Select All",
			value: selectAllLabel || "Select All",
			children: [],
		};

		const processData = (data: any, parentKey: string = ""): TreeNode[] => {
			console.log("processData", data);
			// hardcoded for now
			if (Array.isArray(data)) {
				return data.map((item: any) => {
					return {
						title: item.name || item.project_name,
						key: item.value || item._id,
						value: item.value || item._id,
					};
				});
			}

			return Object.entries(data).map(([key, value]) => {
				const currentKey = parentKey ? `${parentKey}-${key}` : key;
				const node: TreeNode = {
					title: key,
					key: currentKey,
					value: currentKey,
				};

				if (Array.isArray(value)) {
					node.children = value.map((item) => ({
						title: item,
						key: `${currentKey}-${item}`,
						value: `${currentKey}-${item}`,
					}));
				} else if (typeof value === "object" && value !== null) {
					node.children = processData(value, currentKey);
				}

				return node;
			});
		};

		selectAll.children = processData(data);
		return [selectAll];
	};

	useEffect(() => {
		if (!dataObject[name]) {
			throw new Error(`${name} is not in dataObject`);
		}
		setTreeData(convertTreeSelectData(dataObject[name]));
	}, [dataObject]);

	const onChange = (newValue: string[]) => {
		console.log("debug newValue", newValue);
		setValue(newValue);
	};

	const processChild = (value: string) => {
		const [parent, child] = value.split("-");
		return `(${parent}) ${child}`;
	};

	return (
		<div>
			<Form.Item
				label={label}
				name={name}
				rules={[{ required: required, message: "" }]}
				tooltip={
					tooltip
						? {
								title: tooltip,
								icon: GetAntIcon("question3"),
								placement: "right",
								overlayStyle: { maxWidth: "400px" },
							}
						: undefined
				}
			>
				<TreeSelect
					treeData={treeData}
					style={{ width: "100%" }}
					maxTagCount={3}
					value={value}
					dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
					allowClear
					treeNodeLabelProp="title"
					showCheckedStrategy="SHOW_CHILD"
					treeDefaultExpandAll
					onChange={onChange}
					treeCheckable={true}
					// tagRender={(props: any) => {
					// 	const { value, closable, onClose } = props;
					// 	return (
					// 		<Tag
					// 			closable={closable}
					// 			onClose={onClose}
					// 			style={{ marginRight: 3 }}
					// 		>
					// 			{value && value.includes("-") ? processChild(value) : value}
					// 		</Tag>
					// 	);
					// }}
				/>
			</Form.Item>
		</div>
	);
}

export default TreeForm;
